import { IGridComponent } from './grid/i-grid-component';
import { IGridMenuSchema } from './grid/i-grid-menu-schema';
import { IDisplaySchema } from './i-display-schema';
import { ISummitGroupEvent } from './i-summit-group-event';
import { SummitIdObject } from './summit-id-object';

export abstract class GridMenuSchema<T extends SummitIdObject> implements IGridMenuSchema<T> {
  gridComponent?: IGridComponent<T>;
  schema: IDisplaySchema<T>;
  private _parentComponent: unknown;

  getGridParentComponent(): unknown {
    if (!this._parentComponent) this._parentComponent = this.gridComponent?.getParentComponent();
    return this._parentComponent;
  }

  constructor(schema: IDisplaySchema<T>) {
    this.schema = schema;
  }

  getCorrectGroupObject($event: ISummitGroupEvent<T>): Partial<T> {
    return $event.defaultObject;
  }
}
